import { render, staticRenderFns } from "./AssessmentTableAllType.vue?vue&type=template&id=d0fd6910&scoped=true"
import script from "./AssessmentTableAllType.vue?vue&type=script&lang=js"
export * from "./AssessmentTableAllType.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTableAllType.vue?vue&type=style&index=0&id=d0fd6910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fd6910",
  null
  
)

export default component.exports